<script>
import { authComputed } from '@state/helpers'
import {
  notificationComputed,
  notificationMethods,
} from '@state/helpers/notification'

import BasicInfo from '@views/Notification/form/basic-info.vue'
import DeliveryPeriod from '@views/Notification/form/delivery-period.vue'
import DeliveryTarget from '@views/Notification/form/delivery-target.vue'
import Preview from '@views/Notification/form/preview.vue'
import { DELIVERED, PLACE, STATUS_REQUEST } from '@utils/constant'

export default {
  page: {
    title: 'Notification Add New',
    meta: [{ name: 'description', content: 'The Notification Add New page.' }],
  },
  components: {
    BasicInfo,
    DeliveryPeriod,
    DeliveryTarget,
    Preview,
  },
  data() {
    return {
      basic: {},
      previewErrors: {},
      period: {},
      target: {},
      delivered: '0',
      previewed: false,
      openConfirm: false,
      place: {
        app: 1,
        cms: 0,
      },
    }
  },
  computed: {
    ...authComputed,
    ...notificationComputed,
    previewComputed() {
      return !this.previewed
    },
  },
  watch: {
    getStatusAddRequest() {
      if (this.getStatusAddRequest === STATUS_REQUEST.SUCCESS) {
        this.$router.push({ name: 'notificationList' })
      }
    },
  },
  mounted() {
    this.getNotificationQuotes()
  },
  destroyed() {
    // reset all data when destroyed component
    this.resetAfterRegister()
    this.$children[0] &&
      this.$children[0].resetForm &&
      this.$children[0].resetForm()
  },
  methods: {
    ...notificationMethods,
    getNotificationQuotes(place = PLACE.APP) {
      const role = this.getRole
      this.fetchingQuotes({ place, agent_id: role })
    },
    handleBasicInfoData(data) {
      this.basic = data
    },
    handlePeriodData(data) {
      this.period = data
    },
    handleTargetData(data) {
      this.target = data
    },
    handleValidatePreview(error) {
      this.previewErrors = error
    },
    handleDelivered(value) {
      this.delivered = value
    },
    handleRegisterNotification() {
      const basic = {
        ...this.basic,
        place: parseInt(this.basic.place),
        ...(this.basic.image_binary && {
          image_binary: this.basic.image_binary.split(',')[1],
        }),
      }
      if (!basic.order && basic.place === this.place.app) {
        basic.order = 100
      }

      if (basic.place === this.place.cms) {
        basic.order = 99
      }
      let target = null
      if (this.target !== null && this.delivered !== DELIVERED.ON) {
        target = { ...this.target }
        const keys = [
          'age_range_lower',
          'age_range_upper',
          'weight_differ_lower',
          'weight_differ_upper',
          'body_fat_rate_differ_lower',
          'body_fat_rate_differ_upper',
        ]
        for (const key of keys) {
          if (!target[key] && target[key] !== 0) {
            target[key] = -9999
          }
        }
      } else {
        target = null
      }
      this.registerNotification({
        agent_id: this.getRole,
        created_admin_id: this.currentUser.id,
        ...basic,
        ...this.period,
        filter_obj: target ? { ...target } : null,
      })
    },
    handlePreview(pre) {
      this.previewed = pre
    },
    // handleSubmit() {
    //   const errors = {}
    //   if (isSameDay(new Date(this.period?.schedule_start), new Date())) {
    //     errors.schedule_start = [this.$t('validation.notCurrentDay')]
    //   }
    //   if (!this.period?.schedule_start) {
    //     errors.schedule_start = [this.$t('validation.required')]
    //   }
    //   if (!this.period?.schedule_end) {
    //     errors.schedule_end = [this.$t('validation.required')]
    //   }
    //   this.previewErrors = errors
    //   if (isEmpty(this.previewErrors)) {
    //     this.openConfirm = true
    //   }
    // },
    showConfirm() {
      this.openConfirm = true
    },
  },
}
</script>

<template>
  <div id="notification-registration">
    <validation-observer ref="observer" v-slot="{ handleSubmit, failed }">
      <CForm
        class="position-relative"
        @submit.stop.prevent="handleSubmit(showConfirm)"
      >
        <CRow>
          <CCol sm="6">
            <BasicInfo
              ref="BasicInfo"
              :errors="previewErrors"
              @fetching:quote="getNotificationQuotes"
              @change:data="handleBasicInfoData"
            />
            <DeliveryPeriod
              :errors="previewErrors"
              @change:data="handlePeriodData"
            />
            <DeliveryTarget
              :cms="basic.place === '0'"
              @change:data="handleTargetData"
              @change:delivered="handleDelivered"
            />
          </CCol>
          <CCol sm="6">
            <Preview
              :basic="basic"
              :period="period"
              :target="target"
              :delivered="delivered"
              :failed="failed"
              @preview:update="handlePreview"
              @validate="handleValidatePreview"
            />
            <div class="d-flex justify-content-end">
              <CButton
                color="primary"
                type="submit"
                :disabled="previewComputed"
              >
                {{ $t('confirm.add.btn') }}
              </CButton>
              <CButton
                type="button"
                color="dark"
                class="ml-2"
                variant="outline"
                @click="$router.push({ name: 'notificationList' })"
              >
                {{ $t('common.cancel') }}
              </CButton>
            </div>
          </CCol>
        </CRow>
        <BaseModalConfirm
          type="add"
          :show.sync="openConfirm"
          @closeModal="openConfirm = !openConfirm"
          @submit="handleRegisterNotification"
        />
      </CForm>
    </validation-observer>
  </div>
</template>
